import { createContext, useContext } from 'react';

import type { I18nService } from '@web-platform/shared-travel-tools-types/src/i18n-service';

export const I18nContext = createContext<I18nService | null>(null);

export const useI18n = (): I18nService => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nContext.Provider');
  return ctx;
};
